/* istanbul ignore file */
import React from 'react';
import SingleContactsBreadcrumbs from 'domain/sales/contact/shared/SingleContactsBreadcrumbs';
import { NotesBreadcrumbItem } from 'framework/ui/BreadCrumbs';

const ContactTimelineBreadcrumbs = () => {
  return (
    <SingleContactsBreadcrumbs>
      <NotesBreadcrumbItem />
    </SingleContactsBreadcrumbs>
  );
};

export default ContactTimelineBreadcrumbs;
